export enum JobCardType {
    Top = 'Top',
    Normal = 'Normal'
}